import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router";
import usePortfolioFetch from "../../../hooks/usePortfolioFetch";

const LatestProjects = () => {
  const history = useHistory();

  const [projects] = usePortfolioFetch();
  console.log(projects);

  const handleMoredetails = (id) => {
    history.push(`/details/${id}`);
  };

  return (
    <div className="my-5">
      <Container>
        <h2 id="portfolio" className="text-center">
          Portfolio
        </h2>

        <Row xs={1} md={3} className="g-4">
          {projects.map((project) => (
            <Col key={project.id}>
              <Card className="service-card">
                <Card.Img
                  className="card-img"
                  variant="top"
                  src={project.short_img}
                />
                <Card.Body>
                  <h4 className="project-title">{project.name}</h4>
                  <Card.Text>
                    {project.details.slice(0, 100)}
                    ...
                  </Card.Text>
                  <button
                    onClick={() => handleMoredetails(project._id)}
                    className="primary-btn"
                  >
                    More Details
                  </button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default LatestProjects;
